<template>
    <div class="page page-container"></div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import VenProdutoValidation from '@/services/validations/VenProdutoValidation';
import Message from '@/models/Message';

export default {
    components: {

    },
    data() {
        return {
            service: null,
            empresaService: null,
            validation: null,
            idpedido: 0,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-politica-comercial-pacote-kit-grade'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ven-produto-aba-pacote-kit-grade' },
            });

        this.service = new VenProdutoService(this.$http, this.$router);
        this.empresaService = new EmpresaService(this.$http, this.$router);
        this.validation = new VenProdutoValidation(this.msgs);

        this.idproduto = this.$route.params.id;
    },
    methods: {
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin smallbtn() {
    height: 36px;
    font-size: 12px;
    color: $sovis-white;
    @include gradient-button();
}

#main .page.page-container {
    padding: 5px 20px;
}
</style>
